import { type BrandName, getBrandName } from './brand-name';
import { getBrandCopyright } from './get-copyright';
import { getIsAcceptedFreebetMessage } from './get-Is-accepted-freebet-message';
import { getPaymentMethods } from './get-payments';
import { getBrandSEO } from './get-seo';
import { getBrandSocials } from './get-socials';

export {
  BrandName,
  getBrandName,
  getPaymentMethods,
  getBrandSocials,
  getBrandCopyright,
  getBrandSEO,
  getIsAcceptedFreebetMessage,
};
